module.exports = __webpack_public_path__ + "static/media/Guests.b1a0e2e7.svg";